import moment from "moment";
import React, { useState, useEffect } from "react";
import Select from "react-select";
import {
  Dropdown,
  Menu,
  DatePicker,
} from "antd";
import { Link, Switch, Route, useHistory, useParams } from "react-router-dom";
import Creatable from "react-select/creatable";
import { useSelector } from "react-redux";
import Receive from "../../components/reusable/receive";
import {
  usePet,
  useListData,
  presets,
  useToggle,
  stringifyDate,
} from "../../modules";

import NewEmployee from "../../components/drawers/newEmployee";
import EmployeeDetails from "../../components/drawers/employeeDetails";

import {
  AiOutlineDown,
  AiOutlineReload,
} from "react-icons/ai";

const { RangePicker } = DatePicker;

const Employees = () => {
  const [ranges, setRanges] = useState([
    moment().startOf("day"),
    moment().endOf("day"),
  ]);
  const [id, setId] = useState()
  const [selected, setSelected] = useState();
  const [chosen, setChosen] = useState();
  const [string, setString] = useState();
  const [role, setRole] = useState();
  const { user } = useSelector((state) => state.application);

  const [visible, toggleVisible] = useToggle(false)
  const history = useHistory(); 

  const close = () => {
    toggleVisible();
    setTimeout(() => history.goBack(), 300);
  };

  const [{ loading: rLoading, error: rError, fetch: rFetch }, { list: roles }] =
    useListData(
      "roles",
      { string, limit: 100 },
      { notify: true, manual: false }
    );
  
  const [
    { loading, error, fetch: fetchEmployees },
    { list: employees },
    { navigate, Paginate, page = 1, limit = 10 },
  ] = useListData(
    "allEmployees",
    id ? { string, identification: id } : { string },
    { notify: true, manual: false },
    "employees"
    );
       
  const refresh = () => {
    navigate(1);
    fetchEmployees();
  }

  const search = (str) => {
    setString(str);
    refresh()
  };

  const onComplete = ({ data }, notif, ops) => {
    notif(
      `Account has been ${selected?.active ? "deactivated" : "activated"}`,
      ops("success")
    );
    fetch();
  };

  const [, execute] = usePet(
    "toggleActive",
    { id: selected?._id },
    { notify: true, callback: onComplete, manual: true }
  );

  const toggleActive = (usr) => {
    setSelected(usr);
    execute();
  };


  const choose = (id) => {
    let temp = [...chosen];

    if (temp.includes(id)) {
      temp = temp.filter((x) => x !== id);
    } else {
      temp.push(id);
    }

    setChosen(temp);
  };

  const selectRange = (range) => {
    setRanges(range);
  };


  return (
    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
      <div className="sm:flex sm:justify-between sm:items-center mt-2 mb-8">
        <input
          onChange={(e) => search(e.target.value)}
          className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
          id="grid-search"
          type="text"
          placeholder="Employee Name."
        />
        <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
          <RangePicker value={ranges} onChange={selectRange} ranges={presets} />
          <Dropdown
            overlay={
              <Menu>
                <Menu.Item onClick={() => null}>Employee List </Menu.Item>
              </Menu>
            }
          >
            <button className="btn hisani-btn-green-light text-white">
              <span className="hidden xs:block mr-2">Reports</span>
              <AiOutlineDown />
            </button>
          </Dropdown>
        </div>
      </div>

      <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
        <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
          <h2 className="font-semibold text-gray-800">Employees</h2>
          <span className="flex items-center justify-between">
            <Receive error={rError} loading={rLoading} progress>
              <Select
                isClearable
                value={role}
                onChange={setRole}
                styles={{
                  input: (styles) => ({ ...styles, minWidth: "10em" }),
                }}
                options={roles?.map((role) => ({
                  label: role.name,
                  value: role._id,
                }))}
                placeholder="Select Role"
              />
            </Receive>
            <Link to="/app/human-resources/employees/all/new">
              <button className="btn ml-2 hisani-btn-green-light text-white">
                <svg
                  className="w-4 h-4 fill-current opacity-50 flex-shrink-0"
                  viewBox="0 0 16 16"
                >
                  <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                </svg>
                <span className="hidden xs:block ml-2">New Employee</span>
              </button>
            </Link>
            <button
              onClick={refresh}
              className="btn ml-2 py-3 hisani-btn-green-light text-white"
            >
              <AiOutlineReload style={{ color: "white" }} />
            </button>
          </span>
        </header>
        <div className="p-3">
          {/* Table */}
          <div className="overflow-x-auto">
            <Receive error={error} loading={loading} progress>
              {employees.length > 0 ? (
                <table className="table-auto w-full">
                  {/* Table header */}
                  <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                    <tr>
                      <th className="p-2">
                        <div className="font-semibold text-center">No</div>
                      </th>
                      <th className="p-2">
                        <div className="font-semibold text-left">Name</div>
                      </th>
                      <th className="p-2">
                        <div className="font-semibold text-center">Status</div>
                      </th>
                      <th className="p-2">
                        <div className="font-semibold text-center">Date</div>
                      </th>
                      <th className="p-2">
                        <div className="font-semibold text-center"></div>
                      </th>
                    </tr>
                  </thead>
                  {/* Table body */}
                  <tbody className="text-sm font-medium divide-y divide-gray-100">
                    {/* Row */}
                    {employees.map((emp, key) => (
                      <tr>
                        <td className="p-2">
                          <div className="text-center">
                            {(page - 1) * limit + key + 1}.
                          </div>
                        </td>
                        <td className="p-2">
                          <div className="">{emp.name}</div>
                        </td>
                        <td className="p-2">
                          <div
                            className={`text-center ${
                              emp.status ? "text-green-500" : "text-gray-700"
                            }`}
                          >
                            {emp.status ? "Active" : "Inactive"}
                          </div>
                        </td>
                        <td className="p-2">
                          <div className="text-center">
                            {stringifyDate(emp.hireDate)}
                          </div>
                        </td>
                        <td className="p-2 text-center">
                          <Dropdown
                            overlay={
                              <Menu>
                                <Link
                                  to={`/app/human-resources/employees/all/${user?._id}`}
                                >
                                  <Menu.Item>View</Menu.Item>
                                </Link>
                                <Menu.Item>Fire</Menu.Item>
                              </Menu>
                            }
                          >
                            <a
                              className="ant-dropdown-link flex items-center h-10"
                              onClick={(e) => e.preventDefault()}
                            >
                              <span className="mr-2">Actions</span>{" "}
                              <AiOutlineDown />
                            </a>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className="w-full h-16 flex items-center justify-center">
                  <p className="font-semibold text-base">
                    Please click above to add a new Employee
                  </p>
                </div>
              )}
            </Receive>
            {Paginate}
          </div>
        </div>
      </div>
      <Switch>
        <Route path="/app/human-resources/employees/all/new">
          <NewEmployee
            path={"/app/human-resources/employees/all"}
            onPerform={refresh}
          />
        </Route>
        <Route path="/app/human-resources/employees/all/:id">
          <EmployeeDetails />
        </Route>
      </Switch>
    </div>
  );
};

export default Employees;
  